import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgxUiLoaderService } from 'ngx-ui-loader'; // Import NgxUiLoaderService
import { CommonService } from 'src/app/services/api/common.service';
import { ToastrService } from 'ngx-toastr';
import {
  Router,
  NavigationEnd,
  ActivatedRouteSnapshot,
  NavigationStart,
} from '@angular/router';
import { environment } from '../../../environments/environment';
import { NgClass, NgIf } from '@angular/common';
import { SchoolData } from 'src/app/models/schoolUser';
import moment from 'moment';
import { cu } from '@fullcalendar/core/internal-common';
import { AuthenticationService } from 'src/app/services/auth/authentication.service';

declare var $: any;

@Component({
  selector: 'app-swich-back-to-python',
  templateUrl: './swich-back-to-python.component.html',
  styleUrls: ['./swich-back-to-python.component.scss'],
  standalone: true,
  imports: [NgIf],
})
export class SwichBackToPythonComponent implements OnInit {
  @Input() fromComp: any;
  @Input() jobOnly: any;

  currentUrl!: string;
  pageLoad: Boolean = false;
  isAfterApril30: boolean = false;
  public schoolProps!: SchoolData;
  windowLocation: any;
  showSwitchBackSection = false;
  get showSwitchBack(): boolean {
    const createdAtStr =
      this.schoolProps?.properties?.user_access_data?.created_at
    const createdAt = this.parseCreatedAt(createdAtStr);
    if (!createdAt) return false;

    // 7 May 2026
    const cutoff = new Date(2026, 4, 7);
    cutoff.setHours(0, 0, 0, 0);
    createdAt.setHours(0, 0, 0, 0);

    return createdAt >= cutoff;
  }

  private parseCreatedAt(dateStr: string | undefined): Date | null {
    if (!dateStr) return null;

    // Supports DD/MM/YYYY.
    if (dateStr.includes('/')) {
      const [day, month, year] = dateStr.split('/').map(Number);
      if (!day || !month || !year) return null;
      return new Date(year, month - 1, day);
    }

    // Fallback for ISO/other parseable formats.
    const parsed = new Date(dateStr);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }
  constructor(
    private ngxService: NgxUiLoaderService,
    private commonService: CommonService,
    private toastr: ToastrService,
    private _router: Router,
    private authService: AuthenticationService,
    private http: HttpClient
  ) {
    this.windowLocation = window.location.href.split('/');
    const routeUrl = this._router.url;
    if (routeUrl !== '/login' && routeUrl !== '/register' && routeUrl !== '/') {
      this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');
      const currentDate = new Date(
        this.schoolProps.mixpanel_data?.created_at_formated
      );
      const targetDate = new Date('2025-04-30'); // April 30, 2025
      this.isAfterApril30 = currentDate >= targetDate;
    }
  }

  ngOnInit(): void {
    this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');
    this.showSwitchBackSection = this._router.url.includes('school');

    // this.route.events.subscribe((event: any) => {

    //   if (event instanceof NavigationEnd) {
    //     const segments: string[] = [];
    //     let currentRoute: ActivatedRouteSnapshot = this.route.routerState.root.snapshot;
    //     while (currentRoute) {
    //       const path = currentRoute.routeConfig?.path;
    //       if (path && path !== '') { // Filter out these empty paths
    //         segments.push(path);
    //       }
    //       currentRoute = currentRoute.children[0];
    //     }
    //     const rawPath = segments.join('/');
    //     this.pageLoad = rawPath === 'login' || rawPath === 'register' ? false : true;
    //     console.log(this.jobOnly)
    //     console.log(this.pageLoad)

    //   }
    // });
    // this.pageLoad = this.jobOnly != null ? true : false;
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.routerChangeMethod(event.url);
      }
    });
    $(document).ready(function () {
      $('[data-bs-toggle="tooltip"]').tooltip();
    });
  }

  routerChangeMethod(url: any) {
    this.showSwitchBackSection = this._router.url.includes('school');

    this.windowLocation = window.location.href.split('/');
    const routeUrl = this._router.url;
    if (routeUrl !== '/login' && routeUrl !== '/register') {
      this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');
      const currentDate = new Date(
        this.schoolProps.mixpanel_data?.created_at_formated
      );
      const targetDate = new Date('2025-04-30'); // April 30, 2025
      this.isAfterApril30 = currentDate >= targetDate;
    }
    // else if(routeUrl === '/login' || routeUrl === '/register' || routeUrl === '/') {
    //   this.isAfterApril30 = false;
    // }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.pageLoad = this.jobOnly == null || this.jobOnly == true ? false : true;
    this.showSwitchBackSection = this._router.url.includes('school');

    this.windowLocation = window.location.href.split('/');
    const routeUrl = this._router.url;
    if (routeUrl !== '/login' && routeUrl !== '/register') {
      this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');
      const currentDate = new Date(
        this.schoolProps.mixpanel_data?.created_at_formated
      );
      const targetDate = new Date('2025-04-30'); // April 30, 2025
      this.isAfterApril30 = currentDate >= targetDate;
    }
    // else if(routeUrl === '/login' || routeUrl === '/register' || routeUrl === '/') {
    //   this.isAfterApril30 = false;
    // }
  }

  // routerChangeMethod(url: string) {
  //   this.pageLoad = this.jobOnly != null ? true : false;
  // }
  // switchBack() {
  //   this.ngxService.start();
  //   let userId = this.schoolProps.properties.user_access_data.user_id;
  //   // localStorage.clear();
  //   // sessionStorage.clear();
  //   // this._router.ngOnDestroy();
  //   // document.cookie =
  //   //   'refresh_token=; path=/; domain=.' +
  //   //   environment.cookiesDomain +
  //   //   '; expires=' +
  //   //   new Date(0).toUTCString();
  //   // document.cookie =
  //   //   'access_token=; path=/; domain=.' +
  //   //   environment.cookiesDomain +
  //   //   '; expires=' +
  //   //   new Date(0).toUTCString();
  //   // document.cookie =
  //   //   'userRole=; path=/; domain=.' +
  //   //   environment.cookiesDomain +
  //   //   '; expires=' +
  //   //   new Date(0).toUTCString();
  //   // document.cookie =
  //   //   'from=; path=/; domain=.' +
  //   //   environment.cookiesDomain +
  //   //   '; expires=' +
  //   //   new Date(0).toUTCString();
  //   // document.cookie =
  //   //   'bookings_on_off=; path=/; domain=.' +
  //   //   environment.cookiesDomain +
  //   //   '; expires=' +
  //   //   new Date(0).toUTCString();
  //   window.location.replace(environment.apiUrl + 'en/back_to_cc/' + userId);
  //   // setTimeout(() => {
  //   //   this.authService.loggedOut();
  //   //   if (this._router) {
  //   //     this._router.ngOnDestroy();
  //   //   }
  //   // }, 1200);

  //   // const body: any = { tryAngular: false };
  //   // this.http.post(
  //   //   environment.apiUrl + 'en/back-to-cc/' + this.schoolProps.properties.user_access_data.user_id,
  //   //   body,
  //   //   { withCredentials: true }
  //   // ).subscribe(response => {
  //   //   window.location.replace(environment.apiUrl);
  //   // });
  //   // this.commonService.switchBackToPythonTeacher().subscribe({
  //   //   next: (res: any) => {
  //   //     if (res) {
  //   //       // this.authService.loggedOut();
  //   //       // if (this._router) {
  //   //       //   this._router.ngOnDestroy();
  //   //       // }
  //   //       setTimeout(() => {
  //   //         window.location.replace(environment.apiUrl);
  //   //       }, 1200);

  //   //     } else {
  //   //       this.ngxService.stop();
  //   //       this.toastr.error('Error switching back to old ClassCover. Please try again.');
  //   //       console.log('error in the response', res);
  //   //     }
  //   //   },
  //   //   error: (err: any) => {
  //   //     console.log(err);
  //   //     this.toastr.error('Error switching back to old ClassCover. Please try again.');
  //   //     this.ngxService.stop();
  //   //   },
  //   // });
  // }
  switchBack() {
    this.ngxService.start();
    // let userId = this.schoolProps.properties.user_access_data.user_id;
    // window.location.replace(environment.apiUrl + 'en/back_to_cc/' + userId);
    // setTimeout(() => {
    //   this.authService.loggedOut();
    //   if (this._router) {
    //     this._router.ngOnDestroy();
    //   }
    // }, 1200);

    const body: any = { tryAngular: false };
    this.http.post(
      environment.appUrl + 'api/v1/teacher/back-to-cc/',
      body,
      { withCredentials: true }
    ).subscribe(response => {
      window.location.href = environment.appUrl;
    });
    localStorage.clear();
    sessionStorage.clear();
    this._router.ngOnDestroy();
    document.cookie =
      'refresh_token=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
    document.cookie =
      'access_token=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
    document.cookie =
      'userRole=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
    document.cookie =
      'from=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
    document.cookie =
      'bookings_on_off=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
    // this.commonService.switchBackToPythonTeacher().subscribe({
    //   next: (res: any) => {
    //     if (res) {
    //       // this.authService.loggedOut();
    //       // if (this._router) {
    //       //   this._router.ngOnDestroy();
    //       // }
    //       setTimeout(() => {
    //         window.location.replace(environment.apiUrl);
    //       }, 1200);

    //     } else {
    //       this.ngxService.stop();
    //       this.toastr.error('Error switching back to old ClassCover. Please try again.');
    //       console.log('error in the response', res);
    //     }
    //   },
    //   error: (err: any) => {
    //     console.log(err);
    //     this.toastr.error('Error switching back to old ClassCover. Please try again.');
    //     this.ngxService.stop();
    //   },
    // });
  }
}